import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  makeStyles, Typography, Box, Modal, Button, Snackbar, FormControlLabel, Checkbox
} from '@material-ui/core';
import { APP_NAME } from '../../config/constant';
import { Link, Stack } from '@mui/material';
import LoginAgreeSection from './LoginAgreeSection';
import LoginAgreeModal from './LoginAgreeModal';
import useQuery from '../../common/useQuery';
import { api_call } from '../../helpers/untils';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '440px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '30%',
    },
  },

}));

const LoginAgreePage = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = useQuery();
  const token = query.get('q');

  const onClickAgree = async () => {
    const data = { token: token };
    const response = await api_call('/api/auth-agree', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      // close window
      closeWebView();
    } else {
      window.alert("Invalid request!")
    }
  }

  function closeWebView() {
    // flutter_inappwebview
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('closeWebView');
      return;
    }

    // webview_flutter
    if (window.Flutter) {
      Flutter.postMessage('closeWebView');
      return;
    }
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={1500}
        message={toastMessage}
      />

      <div className="bg-light" style={{ width: '100%', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '16px' }}>
        <div style={{ width: '100%', maxWidth: '400px', display: 'block', padding: '16px', border: '1px solid rgba(33, 50, 91, 0.1)', background: '#ffffff', borderRadius: '4px' }}>
          <Typography variant="h6" component="h6">{APP_NAME}</Typography>
          <LoginAgreeSection
            onClickAgree={onClickAgree}
          />
        </div>
      </div>
    </>
  )
}

export default LoginAgreePage;
